
<div class="multiroom-navigator-space-filler" [style.height.px]="height">
    <div class="multiroom-navigator" (window:scroll)="onWindowScroll($event)" [class.scrolled]="enableScrolling" [class.navigatorClosed]="navigatorClosed" [style.width.px]="width" [attr.data-testid]="'multiroom-navigator'">
        <div class="selected-rooms">
            @for (room of rooms; track $index) {
                <div class="selected-room" [class.active]="$index == activeRoom" (click)="setActiveRoom($index)" [class.isEditable]="shopcart && (shopcart.items[$index] || shopcart.items[$index-1])" [attr.data-testid]="'multiroom-navigator-selected-room'">
                    <div class="hoverButton" [attr.data-testid]="'multiroom-navigator-hover-button'">{{"av.changeRoom"|translate}}</div>
                    <div class="row">
                        <div class="col-12">
                            <div class="selected-room-occupants">
                                {{room.adults }} @if(room.adults > 1){{{'sm.adult'|translate}}}@else{{{'sm.adults'|translate}}}, {{room.children}} @if(room.children == 1){{{"sm.child"|translate}}}@else{{{"sm.children"|translate}}}
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        @if (shopcart && shopcart.items[$index]) {
                            <div class="col-12">
                                <div class="selected-room-name">
                                    {{shopcart.items[$index].item?.room?.pim?.name ?? shopcart.items[$index].item?.room?.roomName}}
                                </div>
                            </div>
                            <div class="col-7 pe-0">
                                <div class="selected-room-rate">
                                    {{shopcart.items[$index].item?.rate?.pim?.rateName || shopcart.items[$index].item?.rate?.rateName}}
                                </div>
                            </div>
                            <div class="col-5 selected-room-price">
                                <!-- @if (settings.get("availability.showPricePerNight")) {
                                    {{calculatePricePerNight(shopcart.items[$index].item?.totalPriceForStayWithTaxes) | currency:'EUR':'symbol':'1.0-0' }}
                                }
                                @else { -->
                                    <span [innerHTML]="shopcart.items[$index].item?.totalPriceForStayWithTaxes | displayPrice"></span>
                                <!-- } -->

                            </div>
                        }
                        @else {
                            @if ($index == activeRoom) {
                                <div class="select-room-text d-none d-md-block">{{"av.SelectRoom"|translate}} {{activeRoom + 1}}/{{roomCount}}</div>
                                <div class="select-room-text d-block d-md-none">{{"av.Select"|translate}} {{activeRoom + 1}}/{{roomCount}}</div>

                            }
                        }
                    </div>
                </div>
            }
        </div>

            <div class="total-container" [attr.data-testid]="'multiroom-navigator-total'">
                <div>{{"av.Total"|translate}}</div>
                <div class="selected-room-price">
                    @if (shopcart) {
                        <span [innerHTML]="shopcart.getTotalPrice()|displayPrice"></span>
                    }
                    @else {
                        <span [innerHTML]="'0'|displayPrice"></span>
                    }
                </div>

            </div>


        <div class="multiroom-navigator-toggler" [attr.data-testid]="'multiroom-navigator-toggler'">
            <p-button [rounded]="true" [text]="true" (click)="toggleNavigatorOpen()">
                <span class="material-symbols-outlined">
                    @if(!navigatorClosed) {
                        close
                    }
                    @else {
                        keyboard_arrow_down
                    }
                </span>
            </p-button>

        </div>
    </div>
</div>

@if (shopcart) {
    @if (allSelectedModalShown) {
        <div class="all-selected-modal" [@fadeInOnEnter] [@fadeOutOnLeave] [attr.data-testid]="'multiroom-navigator-all-rooms-selected'">
            <div class="container">
                <h2>{{"av.AllRoomsSelected"|translate}}</h2>
                <div class="row">
                    @for (cartItem of shopcart.items; track $index) {
                        <div class="col-12 col-md-6 all-selected-room-container" [attr.data-testid]="'multiroom-navigator-all-rooms-selected-cart-item'" [attr.data-index]="$index">
                            <h4 class="room-number-header">
                                {{"av.Room" | translate}} {{$index + 1}}
                            </h4>
                            <div class="all-selected-room">

                                <h4>{{cartItem.item.room?.pim?.name ?? cartItem.item.room?.roomName}}</h4>
                                <div class="room-description" [innerHTML]="cartItem.item.room?.pim?.shortDescription"></div>
                                <div class="row mt-auto">
                                    <div class="col-8">
                                        <div class="rate-name">{{cartItem.item|formatRateName}}</div>
                                        <div class="rate-desc" [innerHTML]="cartItem.item?.rate?.pim?.rateDescription ?? cartItem.item?.rate.rateDescription"></div>
                                        <div class="rate-cancel-policy" [innerHTML]="cartItem.item.rate?.pim?.cancellationPolicy"></div>
                                    </div>

                                    <div class="col-4 all-selected-room-price-container">
                                        <span class="rate-price" [innerHTML]="cartItem.item.totalPriceForStayWithTaxes|displayPrice"></span>
                                        <p-button [outlined]="true" class="w-100" (click)="changeRoom($index)" [attr.data-testid]="'multiroom-navigator-all-rooms-selected-continue'">{{"av.changeRoom"|translate}}</p-button>
                                    </div>
                                </div>


                            </div>
                        </div>
                    }
                </div>

                <div class="all-selected-bottom">
                    <div class="row">
                        <div class="col-6">
                            <div>{{"av.Total"|translate}}</div>
                            <div class="all-selected-total-price" [innerHTML]="shopcart.getTotalPrice()|displayPrice" [attr.data-testid]="'multiroom-navigator-all-rooms-selected-total-price'">

                            </div>
                        </div>
                        <div class="col-6 text-end">
                            <p-button [disabled]="(shopcart && shopcart.items.length < roomCount) || !shopcart" (click)="goToProfile()" [attr.data-testid]="'multiroom-navigator-all-rooms-selected-continue'">{{"av.ContinueBooking"|translate}}</p-button>
                        </div>
                    </div>


                </div>

            </div>
        </div>
    }
}



